import { Badge } from '@/components/ui/badge'
import type { Severity } from '@/lib/alerts'

export function SeverityBadge({ severity }: { severity: Severity }) {
  const variant =
    severity === 'critical' || severity === 'error'
      ? 'destructive'
      : severity === 'warning'
        ? 'warning'
        : 'secondary'
  return <Badge variant={variant as 'destructive' | 'warning' | 'secondary'}>{severity}</Badge>
}
